import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_HEIGHT = 400;
const RESIZE_SCRIPT = `<script>
new ResizeObserver(function() {
  window.parent.postMessage(
    { type: 'breeze-iframe-resize', height: document.documentElement.scrollHeight },
    '*'
  );
}).observe(document.documentElement);
</script>`;
function injectResizeScript(html) {
  const closeBodyIndex = html.lastIndexOf('</body>');
  if (closeBodyIndex !== -1) {
    return html.slice(0, closeBodyIndex) + RESIZE_SCRIPT + html.slice(closeBodyIndex);
  }
  return html + RESIZE_SCRIPT;
}
export function InlineDisplayBlock({
  block
}) {
  const {
    mimeType,
    data
  } = block;
  const iframeRef = useRef(null);
  const [height, setHeight] = useState(DEFAULT_HEIGHT);
  const handleMessage = useCallback(event => {
    var _event$data, _iframeRef$current;
    if (((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.type) === 'breeze-iframe-resize' && event.source === ((_iframeRef$current = iframeRef.current) === null || _iframeRef$current === void 0 ? void 0 : _iframeRef$current.contentWindow)) {
      setHeight(event.data.height);
    }
  }, []);
  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [handleMessage]);
  const srcDoc = useMemo(() => injectResizeScript(data), [data]);
  if (mimeType === 'text/html') {
    return /*#__PURE__*/_jsx("div", {
      "data-block-type": "inline-display",
      style: {
        width: '100%'
      },
      children: /*#__PURE__*/_jsx("iframe", {
        ref: iframeRef,
        srcDoc: srcDoc,
        sandbox: "allow-scripts",
        style: {
          width: '100%',
          height: `${height}px`,
          border: 'none',
          borderRadius: '8px'
        }
      })
    });
  }
  return /*#__PURE__*/_jsx("pre", {
    "data-block-type": "inline-display",
    style: {
      whiteSpace: 'pre-wrap'
    },
    children: data
  });
}